module.exports = __webpack_public_path__ + "static/media/32.db44c384.jpg";